module.exports = __webpack_public_path__ + "static/media/before_service1.5b57c664.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/before_service1.pdf
// module id = 780
// module chunks = 2